import React from 'react';
import AbacusContext from '../../abacus/abacus-context';

export default function withAbacus(Component) {
    return function(props) {
        return (
            <AbacusContext.Consumer>
                {(abacus) => {
                    const newProps = {
                        ...props,
                        abacus
                    };
                    return (<Component {...newProps} />);
                }}
            </AbacusContext.Consumer>
        );
    };
}



// WEBPACK FOOTER //
// ./src/universal/abacus/with-abacus/with-abacus.js